import React from 'react';

import { locale, getFileTypesMessage } from '@trqk/utils';

interface AddedWrongFileTypeInput {
    acceptedFileTypes: FileTypeKey[];
    filesWithWrongType: number;
}

/**
 * A toast message shown when a user tries to upload files with the wrong file type.
 */
export const AddedWrongFileType = ({
    input,
}: ToastRenderContentProps<AddedWrongFileTypeInput>): JSX.Element => {
    const filesWithWrongType = input?.filesWithWrongType ?? 0;
    const acceptedFileTypes: FileTypeKey[] = input?.acceptedFileTypes ?? [];

    const acceptedTypesMessage = getFileTypesMessage(acceptedFileTypes);

    const fileOrFiles =
        filesWithWrongType === 1
            ? locale.enUS.TOASTS.ADDED_WRONG_FILE_TYPE.FILE
            : `${filesWithWrongType} ${locale.enUS.TOASTS.ADDED_WRONG_FILE_TYPE.FILES}`;

    return (
        <div style={{ width: 500 }} className="px-2">
            <div className="font-bold text-highlight-orange tracking-wider mb-1">
                {locale.enUS.TOASTS.ADDED_WRONG_FILE_TYPE.UPLOAD_ISSUE}
            </div>
            <div className="my-2">
                {`${locale.enUS.TOASTS.ADDED_WRONG_FILE_TYPE.PART_1} ${fileOrFiles} ${locale.enUS.TOASTS.ADDED_WRONG_FILE_TYPE.PART_2}`}
            </div>
            {acceptedTypesMessage !== null && (
                <div className="my-2">
                    {locale.enUS.TOASTS.ADDED_WRONG_FILE_TYPE.PART_3}{' '}
                    {acceptedTypesMessage}.
                </div>
            )}
        </div>
    );
};
